import React from 'react';
import { useLocation, useParams } from 'react-router-dom'
import PublicLayout from '../../../components/PublicLayout'
import DownloadAuth from '../../../components/download/DownloadAuth'

const App: React.FC = () => {
  const { disseminationKey }: { disseminationKey: string } = useParams()

  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  
  const missingEToursOnly = queryParams.get('missingEToursOnly') || 'false'

  return (
    <PublicLayout>
      <DownloadAuth missingEToursOnly={missingEToursOnly} disseminationKey={disseminationKey} />
    </PublicLayout>
  )
}

export default App;
